import { all } from 'redux-saga/effects';

import designsListSaga from '../actions/designs-list';
import designsCategoriesSaga from '../actions/designs-categories';
import { actionsLoggerSaga } from '../actions/actions-logger';
import { submitDesignSaga } from '../actions/submit-design';

export default function* rootSaga() {
  yield all([
    actionsLoggerSaga(),
    designsListSaga(),
    designsCategoriesSaga(),
    submitDesignSaga()
  ]);
}



// WEBPACK FOOTER //
// ./src/store/sagas.js